export const INPUT_BASE =
    'bg-mp-surface text-mp-foreground border h-11 w-full rounded-lg appearance-none py-2.5 text-sm placeholder:text-mp-muted focus:outline-hidden focus:ring-3';

export const INPUT_PADDING = 'px-4';

export const INPUT_STATE = {
    default: 'border-mp-input focus:border-mp-primary focus:ring-mp-primary/30',
    disabled:
        'border-mp-input cursor-not-allowed opacity-40 focus:border-mp-primary focus:ring-mp-primary/30',
    readOnly: 'border-mp-input cursor-default focus:border-mp-primary focus:ring-mp-primary/30',
    error: 'border-mp-error focus:border-mp-error/80 focus:ring-mp-error/30',
    success: 'border-mp-success focus:border-mp-success/80 focus:ring-mp-success/20',
} as const;
